import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { firbaseAuth } from '../firebase/config';
import { useAuth } from '../context/authContext';
import { LogIn, LogOut, User } from 'lucide-react';

function Header() {
    const [user, setUser] = useState(null);
    const navigate = useNavigate();

    const { userLoggedIn, currentUser } = useAuth();
    console.log('currentUser: ', currentUser?.email.split('@')[0]);

    useEffect(() => {
        if (!userLoggedIn) {
            navigate('/login');
        }
    }, [userLoggedIn]);

    const handleLogout = async () => {
        debugger
        try {
            await firbaseAuth.signOut();
            navigate('/login');
        } catch (error) {
            throw error;
        }
    }

    return (
        <header className="bg-indigo-600 py-1 px-8 flex justify-between items-center fixed top-0 left-0 w-full z-10 shadow-md">
            <div className="flex items-center">
                <Link to="/" className="text-white hover:text-indigo-200">
                    <img src="/images/sitelogo2.png" alt="Your Logo" className='h-10' />
                </Link>
            </div>
            {/* Company Logo in the middle */}
            <div className="absolute left-1/2 transform -translate-x-1/2">
                <Link to="/" className="text-white hover:text-indigo-200">
                    <img src="/images/nexority.png" alt="Company Logo" className='h-12' />
                </Link>
            </div>
            {/* User info and Logout on the right */}
            <div className="flex items-center">
                {userLoggedIn ? (
                    <>
                        <span className="text-white mr-2 flex items-center capitalize">
                            <User className="mr-1 w-4 h-4" />
                            {currentUser?.email?.split('@')[0]}
                        </span>
                        <button
                            onClick={handleLogout}
                            className=" text-red-500 font-bold py-2 px-4 rounded flex items-center"

                        >
                            <LogOut className="mr-2 w-4 h-4" />
                            Logout
                        </button>
                    </>
                ) : (
                    <Link to="/login" className="text-white hover:text-indigo-200 flex items-center">
                           <LogIn className="mr-2 w-4 h-4" />
                        Login
                    </Link>
                )}
            </div>
        </header>
    );
}

export default Header;
